// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand-ordered-nav{color:inherit;text-decoration:underline}.brand-ordered-nav .brand-ordered-icon span{font-weight:500;line-height:28px;font-size:20px}", ""]);
// Exports
module.exports = exports;
